<template>
  <div class="screen page services b-soft">
    <div class="grid">
      <section class="layout">
        <div class="container">
          <div class="row h-items-center">
            <div class="col-12 box-container b-white moves-container no-select">
              <draggable v-if="servicios.length" class="list-container container" v-model="servicios" handle=".handle-products" @change="handleChange">
                <li v-for="servicio in servicios" :key="servicio.id" class="row v-items-center">
                  <div class="col" v-on:click.prevent="goTo('/servicio/'+servicio.id)">
                    <div class="container">
                      <div class="row v-items-center">
                        <div class="col-auto handle-container handle-products">
                          <div class="handle">
                            <span></span>
                            <span></span>
                          </div>
                        </div>
                        <div class="col-auto">
                          <span class="icon-list" v-bind:style="{'background-color': servicio.color}">
                            <b class="t-16-px">{{servicio.abreviacion}}</b>
                          </span>
                        </div>
                        <div class="col">
                          <p class="t-complementary t-14-px">
                            <span>{{servicio.nombre | cutText}}</span>
                            <br>
                            <span class="t-upper t-10-px t-base" v-if="servicio.fecha_creacion">Creado: {{servicio.fecha_creacion.seconds | beautyFormatDate}}</span> <span class="t-upper t-10-px t-base" v-if="servicio.usuario_creador"> Por {{servicio.usuario_creador}}</span><span class="t-upper t-10-px t-base separador-fechas" v-if="servicio.fecha_creacion && servicio.fecha_modificacion"> / </span><span class="t-upper t-10-px t-base" v-if="servicio.fecha_modificacion">Editado: {{servicio.fecha_modificacion.seconds | beautyFormatDate}}</span> <span class="t-upper t-10-px t-base" v-if="servicio.usuario_editor"> Por {{servicio.usuario_editor}}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-auto">
                    <a href="#" class="t-complementary" v-on:click.prevent="deleteElement('servicios', servicio.id)">
                      <i class="fa fa-trash"></i>
                    </a>
                  </div>
                 </li>
              </draggable>
              <p v-else class="t-center">
                <i class="fas fa-sad-cry t-48-px"></i>
                <br>
                <br>
                No se encontraron servicios
              </p>
            </div>
          </div>
        </div>
      </section>
      <GetFooter />
    </div>
  </div>
</template>

<script>
import GetFooter from '@/components/footer.vue'
import router from '@/router'
import { db } from '@/firebase'
import draggable from 'vuedraggable'
export default {
  name: 'app',
  components: {
    GetFooter,
    draggable
  },
  data() {
    return {
      servicios: []
    }
  },
  firestore () {
    return {
      servicios: db.collection('servicios').orderBy('orden', 'asc')
    }
  },
  methods: {
    handleChange() {
      for (var i = 0; i < this.servicios.length ; i++) {
        //Actualizar elemento
        db.collection('servicios').doc(this.servicios[i].id).update({
          orden: i + 1
        })
        .then(function(doc) {
          //Se actualizo con exito el documento
          console.log('Orden Actualizado')
        })
        .catch(function(error) {
          //Error al actualizar
          console.log('Error al actualizar')
        })
      }
    },
    goTo (url){
      router.push({path: url})
    },
    deleteElement(collection, id){
      if(window.confirm('¿Estás Seguro? Esto eliminará el elemento permanentemente.')){
        db.collection(collection).doc(id).delete().then(function() {
          console.log('Document successfully deleted!')
        }).catch(function(error) {
          alert('Error de ejecución')
          console.error('Error removing document: ', error)
        })
      }
    }
  }
}
</script>